import { render, staticRenderFns } from "./hedefkarti.vue?vue&type=template&id=4fa0ad40"
import script from "./hedefkarti.vue?vue&type=script&lang=js"
export * from "./hedefkarti.vue?vue&type=script&lang=js"
import style0 from "./hedefkarti.vue?vue&type=style&index=0&id=4fa0ad40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports